import { Fragment, ReactElement } from "react";
import { Chip } from "@material-ui/core";
import { PortfolioCard } from "store/card";
import { DialogWrapper, DialogWrapperType } from "../../../shared/dialog/index";
import CallIcon from "@material-ui/icons/Call";
import SmartphoneIcon from "@material-ui/icons/Smartphone";
import PhoneForwardedIcon from "@material-ui/icons/PhoneForwarded";
import PhoneInTalkIcon from "@material-ui/icons/PhoneInTalk";

import style from "./call-dialogue.module.scss";

export interface CallDialogProps {
  open: boolean;
  onClose(): void;
  portfolioCard: PortfolioCard;
  colour: string;
}

export const CallDialog = ({
  open,
  onClose,
  portfolioCard,
  colour,
}: CallDialogProps) => {
  let numbers: { title: string; content: string; icon: ReactElement }[] = [];

  if (portfolioCard.number && portfolioCard.number.toString().trim()) {
    numbers.push({
      title: "Phone",
      content: portfolioCard.number,
      icon: <CallIcon style={{ color: colour }} />,
    });
  }

  if (portfolioCard.mobile && portfolioCard.mobile.toString().trim()) {
    numbers.push({
      title: "Mobile",
      content: portfolioCard.mobile,
      icon: <SmartphoneIcon style={{ color: colour }} />,
    });
  }

  if (portfolioCard.tollFree && portfolioCard.tollFree.toString().trim()) {
    numbers.push({
      title: "Toll Free",
      content: portfolioCard.tollFree,
      icon: <PhoneInTalkIcon style={{ color: colour }} />,
    });
  }

  if (portfolioCard.direct && portfolioCard.direct.toString().trim()) {
    numbers.push({
      title: "Direct",
      content: portfolioCard.direct,
      icon: <PhoneForwardedIcon style={{ color: colour }} />,
    });
  }

  return (
    <DialogWrapper
      type={DialogWrapperType.DEFAULT}
      open={open}
      onClose={onClose}
      maxWidth={"xs"}
      title="Calling Options"
    >
      <div className={style.content}>
        {numbers.map((item, idx) => (
          <a target="_new" href={`tel://${item.content}`} key={idx}>
            <Chip
              clickable
              label={
                <Fragment>
                  <div>{item.title}</div>
                  <div className={style.number}>{item.content}</div>
                </Fragment>
              }
              className={style.chip}
              avatar={item.icon}
            />
          </a>
        ))}
      </div>
    </DialogWrapper>
  );
};
